import $ from 'jquery';

function toggleDropdown(e) {
  if (document.documentElement.clientWidth < 721) {
    e.preventDefault();
    $(e.target).parent().toggleClass('open');

    return false;
  }
  return undefined;
}

export default class Sidebar {
  constructor({ el }) {
    this.$el = $(el);
    $('.has-children > a', this.$el).on('click', toggleDropdown);
  }
}
